import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { Membership } from "../../../business-objects/membership/membership.model";
import { AclCategoryModalController } from "./acl-category-modal.controller";
import { AclCategoryModalModel } from "./acl-category-modal.model";
import { BaseComponent } from "../../../../core/components/base.component";
import { AclCategoryModalItemModel } from "./acl-category-modal-item.model";
import { VasAppFacade } from "../../../services/vas-app-facade.service";
import { SelectOption } from "../../../../core/interfaces/select-option";
import { FormGroup } from "@angular/forms";

export interface IAclCategoryModalArgs {
    categoryType: string;
    categoryId: string;
    memberships: Array<Membership>;
}

@Component({
    selector: "acl-category-modal",
    templateUrl: "./acl-category-modal.component.html",
    viewProviders: [
        {
            provide: AclCategoryModalController,
            useClass: AclCategoryModalController,
            deps: [VasAppFacade, ViewController]
        }
    ]
})
export class AclCategoryModalComponent extends BaseComponent {

    protected model: AclCategoryModalModel;

    constructor(
        public navParams: NavParams,
        protected controller: AclCategoryModalController
    ) {
        super();
    }

    ngOnInit(): void {

        this.controller.model$
            .takeUntil(this.ngUnsubscribe)
            .subscribe(model => this.model = model);

        this.controller.ngOnInit(this.navParams);
    }

    ionViewCanEnter(): boolean {
        return this.controller.ionViewCanEnter(this.navParams);
    }

    get filterFormGroup(): FormGroup {
        return this.model ? this.model.filterFormGroup : undefined;
    }

    get items(): Array<AclCategoryModalItemModel> {
        return this.model ? this.model.items : [];
    }

    get accessGroupOptions(): Array<SelectOption> {
        return this.model ? this.model.accessGroupOptions : [];
    }

    onSubmit(): void {
        this.controller.submit(this.model);
    }

    onToggle(itemModel: AclCategoryModalItemModel): void {
        this.controller.toggle(this.model, itemModel);
    }

    onCancel(): void {
        this.controller.dismiss();
    }

    onAllowAll(): void {
        this.controller.grantAll(this.model);
    }

    onDenyAll(): void {
        this.controller.revokeAll(this.model);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/acl-category/form/acl-category-modal.component.ts